<template>
  <div class="v-tabs">
    <nav class="v-tabs__header">
        <ul class="v-tabs__list">
          <li class="v-tabs__item"
            :class="{ 'v-tabs__item--is-selected': selectedLang === lang }"
            v-for="lang in langs"
            @click="selectLang(lang)">

            <button class="v-tabs__button" @click.prevent>
              {{ lang.name }}
            </button>
          </li>
        </ul>
    </nav>

    <div class="v-tabs__body" v-for="lang in langs" v-show="lang === selectedLang">
      <slot :lang="lang"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['inputingLocale']),
    selectedLang () {
      return this.langs.find(item => item.code === this.inputingLocale) || this.langs[0]
    }
  },
  data () {
    return {
    }
  },
  methods: {
    selectLang (lang) {
      window.app.$store.commit('SET_INPUTING_LOCALE', lang.code)
    }
  },
  props: {
    isOpen: {
      default: true,
      type: Boolean,
    },
    langs: {
      default: () => [],
      type: Array,
    },
    values: {
      default: () => [],
      type: Array,
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/VTabs.vue